<!--
 * @Author: yeweimao yeweimao@zhuanzhuan.com
 * @Date: 2022-08-27 20:14:34
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-10-13 15:42:10
 * @FilePath: /b2c_public_components/src/zz-report-pop-item/src/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <section ref="container">
    <z-popup
      v-model="showCondition"
      position="bottom"
      class="b2cui-pop-wrapper"
      :style="{ minHeight: isRequest ? '55vh' : '35vh' }"
      :get-container="getContainer"
      @click-overlay="clickOverlay"
    >
      <div v-zpm="{ areaexposure: 123 }" class="pop-title">
        <span>{{ popTitle || '' }}</span>
        <div class="mask_img" @click="togglePopup">
          <img
            src="https://pic6.zhuanstatic.com/zhuanzh/1b8afb9f-426f-46dc-92b2-4cc6dcfdcce3.png"
          />
        </div>
      </div>
      <div class="params-desc">
        <div v-for="(item, index) in qcWikiDesc" :key="index" class="item-desc">
          {{ item }}
        </div>
      </div>
      <div id="popWrapper" class="pop_wrapper">
        <div :style="{ minHeight: isRequest ? '38vh' : '30vh' }">
          <!-- 质检报告 -->
          <div v-if="standardDefines && standardDefines.length" class="report_list">
            <div
              v-for="(item, index) in standardDefines"
              :key="index"
              :class="['item_report', item.mark == 1 ? 'active' : '']"
            >
              <div class="report_value">{{ item.qcItemName }}</div>
              <div class="report_valueDesc">
                <div v-for="(zItem, zIndex) in item.defineDesc" :key="zIndex">{{ zItem }}</div>
              </div>
            </div>
          </div>
          <!-- 质检九宫格数据 -->
          <!-- <div
            v-if="
              reportData.qcWiki &&
              reportData.qcWiki.qcWikiDesc &&
              reportData.qcWiki.qcWikiDesc.length
            "
            class="report_list"
          >
            <div
              v-for="(item, index) in reportData.qcWiki.qcWikiDesc"
              :key="index"
              :class="['item_report active']"
            >
              <div class="report_valueDesc_nine">
                {{ item }}
              </div>
            </div>
          </div> -->

          <div
            v-if="impactDesc && impactDesc.length && impactDesc[0] !== ''"
            class="impactDesc-content"
          >
            <div class="impactDesc-title">使用体验有什么差异？</div>
            <div class="impactDesc-list">
              <div v-for="(item, index) in impactDesc" :key="index" class="item-impactDesc">
                {{ item }}
              </div>
            </div>
          </div>
          <div
            v-if="
              nineStandardDefines && nineStandardDefines.length && nineStandardDefines[0] !== ''
            "
            class="standardDefines"
          >
            <div class="standardDefines-list">
              <div
                v-for="(item, index) in nineStandardDefines"
                :key="index"
                :class="['item-content', item.mark === 1 ? 'active' : '']"
              >
                <div class="item-label">{{ item.qcItemName }}</div>
                <div class="item-value">
                  <span v-for="(list, i) in item.defineDesc" :key="list.valueText"
                    >{{ list }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="smallEncyclopediaPic" class="report_photo">
            <img class="img_report" :src="$setPicSize(smallEncyclopediaPic, 1000, 1000)" />
          </div>
        </div>
        <div v-if="isRequest" class="pop_feedback">
          <div v-if="helpType === 0" class="no_feedback">
            <div class="feedback_img" @click="helpClick()">
              <img
                class="icon_input"
                :src="
                  $setPicSize(
                    'https://pic4.zhuanstatic.com/zhuanzh/78646561-eb4c-42cd-a7f3-ff866df78bb6.png',
                    80,
                    80
                  )
                "
              />
              <span>有帮助</span>
            </div>
            <i class="line"></i>
            <div class="feedback_img" @click="noHelpClick()">
              <img
                class="icon_input"
                :src="
                  $setPicSize(
                    'https://pic2.zhuanstatic.com/zhuanzh/1fa08c3a-0f0b-4ec8-8597-0c33421155cf.png',
                    80,
                    80
                  )
                "
              />
              <span>无帮助</span>
            </div>
          </div>
          <div class="have_help">
            <div v-if="helpType === 1" class="have_feedback_img active">
              <img
                class="icon_input"
                :src="
                  $setPicSize(
                    'https://pic4.zhuanstatic.com/zhuanzh/d602018f-8c64-462e-87b9-c73a2f4763ee.png',
                    80,
                    80
                  )
                "
              />
              <span>有帮助</span>
            </div>
            <div v-if="helpType === 2" class="have_feedback_img">
              <img
                class="icon_input"
                :src="
                  $setPicSize(
                    'https://pic3.zhuanstatic.com/zhuanzh/7b0bb22e-2966-4f1d-8d52-d507db595518.png',
                    80,
                    80
                  )
                "
              />
              <span>无帮助</span>
            </div>
          </div>
        </div>
      </div>
      <QualityFeedback
        ref="feedback"
        :showBack="true"
        :qcCode="qcCode"
        :firstItemId="firstItemId"
        :secondItemId="secondItemId"
        :thirdItemId="thirdItemId"
        :channelId="channelId"
        :cateId="cateId"
        :popTitle="`验机百科-${popTitle}`"
        :jggId="jggId"
        :mainTitle="`您对${popTitle}有什么反馈或建议吗？`"
        @complete="completeFeedback"
      />
    </z-popup>
  </section>
</template>
<script>
  import { Popup, SimpleSticky, Checker, Field, Button, CellGroup, Toast } from '@zz-common/zz-ui'
  import { lego } from '@zz-common/lego'
  import { setPicSize } from '@zz-common/zz-utils'
  // import QualityFeedback from './quality-feedback.vue'
  import QualityFeedback from '../../quality-feedback/index'
  import { getQcHelpfulCount, incrQcHelpfulCount } from '../../apis/index'

  export default {
    name: 'zz-report-pop-item',
    components: {
      [Popup.name]: Popup,
      [SimpleSticky.name]: SimpleSticky,
      [Checker.name]: Checker,
      [Field.name]: Field,
      [CellGroup.name]: CellGroup,
      [Button.name]: Button,
      QualityFeedback,
    },
    props: {
      report: {
        type: Object,
        default: () => {},
      },
      qcCode: {
        type: String,
        default: () => '',
      },
      isRequest: {
        type: Boolean,
        default: () => false,
      },
      pageId: {
        type: String,
        default: 'T2974',
      },
      cateId: {
        type: [Number, String],
        default: '',
      },
      getContainer: {
        type: [String, Object],
        default: null,
      },
    },
    data() {
      return {
        popTitle: '',
        standardDefines: [],
        // smallEncyclopediaPic: '',
        reportData: {},
        container: null,
        helpType: 0,
        firstItemId: '',
        secondItemId: '',
        thirdItemId: '',
        channelId: 1, // 渠道id
        otherText: '',
        showCondition: false,
        jggId: '',
        qcWiki: null, // 九宫格数据
      }
    },
    computed: {
      $setPicSize() {
        return setPicSize
      },
      /**
       * $ 百科信息
       */
      qcWikiDesc() {
        return this.qcWiki && this.qcWiki.qcWikiDesc ? this.qcWiki.qcWikiDesc : []
      },
      /**
       * $ 网络制式数据  优先取它，没有的话取 解释说明impactDesc数据
       */
      nineStandardDefines() {
        return this.qcWiki && this.qcWiki.standardDefines ? this.qcWiki.standardDefines : []
      },
      /**
       * $ 解释说明
       */
      impactDesc() {
        return this.qcWiki && this.qcWiki.impactDesc ? this.qcWiki.impactDesc : []
      },
      /**
       * $ 验机百科图片
       */
      smallEncyclopediaPic() {
        return this.qcWiki && this.qcWiki.qcWikiImg ? this.qcWiki.qcWikiImg : ''
      },
    },
    mounted() {},
    methods: {
      async getHelpCount() {
        const params = {
          qcCode: this.qcCode,
          firstItemId: this.firstItemId,
          secondItemId: this.secondItemId,
          thirdItemId: this.thirdItemId,
          channelId: this.channelId,
          jggId: this.jggId,
          cateId: this.cateId,
        }
        const { data } = await getQcHelpfulCount({ request: params })
        this.helpType = data.helpType || 0
      },

      // $ 弹窗展示
      togglePopup(data) {
        // $ 重置数据 兼容处理 后期重构要改掉这部分逻辑
        this.qcWiki = null
        const { qcWiki } = data
        this.reportData = data
        if (qcWiki) this.qcWiki = data.qcWiki
        /**
         * $ 质检标题逻辑 如果有data.title 说明是从质检报告打开查看验机百科 否则就是九宫格
         */
        if (data.title) {
          this.popTitle = `${data.title}-${data.name}`
        } else {
          this.popTitle = `${data.key}: ${data.value}`
        }

        this.standardDefines = data.standardDefines // $ 质检项
        // this.smallEncyclopediaPic = data.smallEncyclopediaPic // $ 质检小图标 唐超质检报告迭代需求 取消此字段取图片逻辑 从九宫格取

        this.showCondition = !this.showCondition
        this.firstItemId = data.firstItemId || ''
        this.secondItemId = data.itemId || ''
        this.thirdItemId = (data.values && data.values[0].valueId) || ''
        this.otherText = data.otherText || ''
        const isNineQualityPoup = !!(data.from == 'nine')
        if (data.from == 'nine') {
          this.channelId = 12
        } else if (data.from == 'quality') {
          this.channelId = 1
        }
        // 九宫格id
        const { id: jggId = '' } = data
        this.jggId = jggId
        if (this.showCondition) {
          this.$nextTick(() => {
            if (this.showCondition) document.getElementById('popWrapper').scrollTop = 0
          })
          this.isRequest && this.getHelpCount()

          // $ 弹窗展示埋点
          lego.send({
            pagetype: 'PopupShow',
            actiontype: this.pageId,
            backup: {
              popupname: isNineQualityPoup
                ? '九宫格弹窗'
                : `${this.otherText || ''}质检报告二级质检项弹窗`,
              name: data.name,
              itemId: data.itemId,
            },
          })
        } else {
          lego.send({
            pagetype: 'PopupClick',
            actiontype: this.pageId,
            backup: {
              popupname: isNineQualityPoup ? '关闭九宫格弹窗' : `关闭质检报告二级质检项弹窗`,
              sortId: 0,
              sortname: '关闭',
            },
          })
        }
      },

      // $ 有帮助
      helpClick() {
        const params = {
          qcCode: this.qcCode,
          firstItemId: this.firstItemId,
          secondItemId: this.secondItemId,
          thirdItemId: this.thirdItemId,
          channelId: this.channelId,
          jggId: this.jggId,
          cateId: this.cateId,
        }
        incrQcHelpfulCount({ request: JSON.stringify(params) })
          .then(() => {
            Toast.success({
              duration: 800,
              message: '感谢反馈',
            })
            lego.send({
              pagetype: 'zpmclick',
              actiontype: this.pageId,
              backup: {
                sortId: 0,
                sortName: '有帮助',
                qcCode: this.qcCode,
                firstItemId: this.firstItemId,
                secondItemId: this.secondItemId,
                thirdItemId: this.thirdItemId,
              },
            })
            this.showCondition = false
            this.helpType = 1
          })
          .catch((err) => {
            Toast({
              duration: 800,
              message: err.errorMsg,
            })
          })
      },

      // $ 无帮助打开反馈弹窗
      noHelpClick() {
        this.$refs.feedback.feedBackShow = true
        this.$refs.feedback.feedbackOptions()
      },
      // $ 提交质检项反馈完成
      completeFeedback(backup) {
        this.showCondition = false
        lego.send({
          pagetype: 'zpmclick',
          actiontype: this.pageId,
          backup,
        })
      },
      clickOverlay() {
        this.$refs.feedback.closeFeedback()
      },
    },
  }
</script>

<style lang="scss">
  @import '@zz-common/zz-ui/lib/style/animation.scss';
  .b2cui-pop-wrapper {
    padding-top: 24px;
    max-height: 70vh;
    overflow-y: auto;
    flex-direction: column;
    display: flex;
    justify-content: space-between;
    .pop-title {
      flex-shrink: 0;
      position: relative;
      height: 148px;
      line-height: 70px;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #111;
      text-align: center;
      background: url(//pic1.zhuanstatic.com/zhuanzh/239a2937-a06b-4015-a719-462b7ae5bf28.png)
        no-repeat 0 0;
      background-size: cover;
      margin-top: -24px;
      // margin-bottom: 20px;
      padding-top: 25px;
      box-sizing: border-box;
      span {
        position: absolute;
        bottom: -12px;
        left: 32px;
      }
      .mask_img {
        position: absolute;
        top: 21px;
        right: 32px;
        width: 48px;
        height: 48px;
        img {
          width: 24px;
          height: 24px;
        }
      }
    }
    .params-desc {
      padding: 12px 32px 0;
      .item-desc {
        margin-top: 10px;
        margin-bottom: 24px;
        color: #111;
        font-weight: 400;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 40px;
      }
    }
    .pop_wrapper {
      padding: 0 32px calc(constant(safe-area-inset-bottom));
      padding: 0 32px calc(env(safe-area-inset-bottom));

      padding-bottom: 40px;
      flex: 1;
      overflow: auto;
      .report_list {
        .item_report {
          display: flex;
          .report_value {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 136px;
            margin: 0 4px 4px;
            padding: 32px 19px;
            color: #999;
            background: #f8f9fd;
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
          }
          .report_valueDesc {
            width: calc(100% - 140px);
            margin-bottom: 4px;
            padding: 32px;
            background: #f8f9fd;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999;
            line-height: 40px;
          }
          .report_valueDesc_nine {
            width: 100%;
            margin-bottom: 4px;
            padding: 32px;
            background: #f8f9fd;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999;
            line-height: 40px;
          }
        }
        .active {
          .report_value,
          .report_valueDesc {
            color: #111;
          }
          .report_valueDesc_nine {
            color: #111;
          }
          .report_value {
            font-family: PingFangSC-Semibold, PingFang SC;
          }
        }
        .item_report:first-child {
          .report_value {
            border-top-left-radius: 12px;
          }
          .report_valueDesc,
          .report_valueDesc_nine {
            border-top-right-radius: 12px;
          }
        }
        .item_report:last-child {
          .report_value {
            border-bottom-left-radius: 12px;
          }
          .report_valueDesc,
          .report_valueDesc_nine {
            border-bottom-right-radius: 12px;
          }
        }
      }

      .impactDesc-content {
        padding: 28px 32px;
        background: #f8f9fd;
        border-radius: 12px;
        margin-bottom: 20px;
        .impactDesc-title {
          margin-bottom: 20px;
          color: #111;
          font-weight: 500;
          font-size: 26px;
          font-family: PingFangSC-Medium, PingFang SC;
          line-height: 32px;
        }
        .impactDesc-list {
          .item-impactDesc {
            margin-bottom: 32px;
            color: #111111;
            font-weight: 400;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            line-height: 40px;
          }
        }
      }

      .standardDefines-list {
        overflow: hidden;
        border-radius: 12px;
        .item-content {
          display: flex;
          color: #999;
          font-weight: 400;
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          line-height: 32px;
          .item-label {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 168px;
            margin: 0 0 4px;
            padding: 27px 10px 27px 20px;
            background: #f8f9fd;
            border-right: 4px solid #fff;
          }
          .item-value {
            width: calc(100% - 172px);
            margin-bottom: 4px;
            padding: 27px 10px 27px 20px;
            background: #f8f9fd;
          }
        }
        .active {
          color: #111;

          .item-label {
            font-weight: 600;
            font-family: PingFangSC-Semibold, PingFang SC;
          }
        }
      }

      .report_photo {
        margin-top: 48px;
        border-radius: 12px;
        overflow: hidden;
        // background: #f8f8f8;
        .img_report {
          width: 100%;
          height: auto;
          border-radius: 12px;
          max-height: 100%;
        }
      }
    }
    .pop_feedback {
      // width: 100%;
      font-size: 30px;
      text-align: center;
      padding: 60px 0 0;
      .no_feedback {
        width: 440px;
        height: 80px;
        border-radius: 40px;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 200%;
          height: 200%;
          border-radius: 80px;
          border: 1px solid #f0f0f0;
          transform-origin: 0 0;
          transform: scale(0.5, 0.5);
          box-sizing: border-box;
          z-index: -1;
        }
        .feedback_img {
          width: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 40px;
            height: 40px;
            margin-right: 16px;
          }
          span {
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666;
          }
        }
        .line {
          position: relative;
          width: 1px;
          height: 40px;
          // background: #f0f0f0;
          &::after {
            content: ' ';
            position: absolute;
            right: -2px;
            top: 50%;
            width: 1px;
            height: 80px;
            border-right: 1px solid #f0f0f0;
            transform-origin: 0 0;
            transform: scale(0.5) translateY(-50%);
          }
        }
      }
      .have_help {
        .have_feedback_img {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 240px;
          height: 80px;
          background: #f8f8f8;
          border-radius: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #111;
          margin: 0 auto;
          img {
            width: 40px;
            height: 40px;
            margin-right: 16px;
          }
          span {
            font-size: 28px;
          }
        }
        .have_feedback_img.active {
          background: #fff2f2;
          color: #ff483c;
        }
      }
    }
    .z-cell {
      background: #f8f8f8;
      border-radius: 16px;
      .z-field__control {
        user-select: auto;
        font-size: 26px;
      }
      textarea::placeholder {
        color: #c6c6c6;
      }
    }
  }
</style>
